import { env } from '@/config'

const messageDomain = env === 'sandbox'?
'wss://message.sandbox.shubox.com':
'wss://push.shubox.com'

export default messageDomain